import React from 'react';

import {Link} from 'react-router';

import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {FixableHeader, FixableTable} from './utils';

import type {
  DocTaskReportItemType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<DocTaskReportItemType>;
}

export function RenderMostVisitedDocuments({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{gt('Visits')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r['name']}
              </Link>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td className="text-right">{r['count']}</td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
